import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const EventsTableInfo = withConfig(theme => styled('div', { label: 'EventsTableInfo' })`
    border-top: 1px solid ${theme.star.eventsTableColors.borderColor};
    padding: 15px 5px 10px 5px;
    position: relative;
    text-align: center;
    flex: 1;
    justify-content: center;
    display: flex;
    align-items: center;
`);

export const InfoIconUnifiedWrapper = withConfig(theme => styled('div', { label: 'InfoIconUnifiedWrapper' })`
    display: flex;
    padding: 12px;
    justify-content: center;
    align-items: center;
    border-radius: ${theme.star.radius.circular};
    background: ${theme.star.unified.eventsTableInfo.bgColorSecondary};
    width: 56px;
`);

export const EventsTableUnifiedWrapper = withConfig(theme => styled('div', { label: 'EventsTableUnifiedWrapper' })`
    flex: 1;
    display: flex;
    flex-flow: column;
    background: ${theme.star.unified.eventRow.bgColor};

    & [class$='EventsTableInfo'] {
        min-height: 320px;
        flex-flow: column;
        background: ${theme.star.unified.eventsTableInfo.bgColor};
        gap: ${theme.star.gap.large};
        font-size: ${theme.star.fontSize.xRegular};
        font-weight: ${theme.star.fontWeight.xMedium};
        line-height: ${theme.star.lineHeight[250]};

        rect {
            fill: ${theme.star.unified.eventsTableInfo.fill};
        }
    }
`);

interface FootballFiltersWrapperPropsType {
    variant: DefaultComponentVariantType | null;
    renderEventFilters: boolean;
}

const setFootballFiltersWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, renderEventFilters: boolean): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            @media ${theme.star.mediaQuery.tablet} {
                margin: ${renderEventFilters ? '0 8px' : '8px 8px 0'};
                border-radius: ${renderEventFilters ? '0' : '8px 8px 0 0'};
            }
        `;
    }
    return css`
        border: 1px solid ${theme.star.filtersColors.wrapper.borderColor};
    `;
};

export const FootballFiltersWrapper = withConfig(theme => styled('div', { label: 'FootballFiltersWrapper' })<FootballFiltersWrapperPropsType>`
    ${({ variant, renderEventFilters }): SerializedStyles => setFootballFiltersWrapper(variant, theme, renderEventFilters)}
    background-color: ${theme.star.filtersColors.wrapper.bgColorTertiary};
    padding: 8px 0 8px 8px;
`);

